/* istanbul ignore file */

/* tslint:disable */

/* eslint-disable */
export var BusinessActivityStatus;

(function (BusinessActivityStatus) {
  BusinessActivityStatus["ACCEPT"] = "accept";
  BusinessActivityStatus["HIDDEN"] = "hidden";
})(BusinessActivityStatus || (BusinessActivityStatus = {}));